import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import { put, takeLatest } from "redux-saga/effects";
import { getUserByToken } from "./homepageCrud";
import { utils } from "react-modern-calendar-datepicker";

export const actionTypes = {
  setVariable: "[homepage] setVariable Action",
  changeBackPanel: "[homepage] ChangeBackPanel Action",
  changePassengerPanel: "[homepage] changePassengerPanel Action",
  loadTownships: "[homepage] loadTownships Action",
  townshipsLoaded: "[homepage] townshipsLoaded Action",
  searchForNewDate: "[homepage] searchForNewDate Action",
  setSliders: "[setSliders] setSliders Action",
  setBanners: "[setBanners] setBanners Action",
  setIcons: "[setIcons] setIcons Action",
  setBlogs: "[setBlogs] setBlogs Action",
  setMobileDialog: "[setMobileDialog] setMobileDialog Action",
};

export const initialHomepageState = {
  round_trip: 0,
  initiated: false,
  source_id: null,
  dest_id: null,
  departure_datetime: null,
  adult_count: 1,
  child_count: 0,
  bike_count: 0,
  backPlan: false,
  passenger_panel: false,
  is_form_ready: false,
  range_open: false,
  townships: [],
  sliders: undefined,
  banners: undefined,
  icons: undefined,
  round_trip_range: {
    from: null,
    to: null,
  },
  blogs: undefined,
  mobileDialogOpen: false,
};

export const reducer = (state = initialHomepageState, action) => {
  switch (action.type) {
    case actionTypes.setVariable: {
      const varName = action.varName;
      let prp = { ...state };
      prp[varName] = action.payload;
      return prp;
    }
    case actionTypes.changeBackPanel: {
      return { ...state, backPlan: action.payload };
    }
    case actionTypes.changePassengerPanel: {
      return { ...state, passenger_panel: action.payload };
    }
    case actionTypes.setMobileDialog: {
      return { ...state, mobileDialogOpen: action.payload };
    }
    case actionTypes.loadTownships: {
      return { ...state, townships: action.payload, is_form_ready: true };
    }
    case actionTypes.setIcons: {
      return { ...state, icons: action.payload };
    }
    case actionTypes.setBlogs: {
      return { ...state, blogs: action.payload };
    }
    case actionTypes.searchForNewDate: {
      return {
        ...state,
        departure_datetime: action.date,
        is_form_ready: false,
      };
    }
    case actionTypes.setSliders: {
      return { ...state, sliders: action.payload };
    }
    case actionTypes.setBanners: {
      return { ...state, banners: action.payload };
    }
    default:
      //TODO: setDeparture datetime here
      return { ...state };
  }
};

export const actions = {
  handle_variables: (varName, value) => ({
    type: actionTypes.setVariable,
    varName: varName,
    payload: value,
  }),
  change_backPanel: (state) => ({
    type: actionTypes.changeBackPanel,
    payload: state,
  }),
  change_passenger_panel: (state) => ({
    type: actionTypes.changePassengerPanel,
    payload: state,
  }),
  loadTownships: (data) => ({ type: actionTypes.loadTownships, payload: data }),
  setSliders: (payload) => ({ type: actionTypes.setSliders, payload }),
  setBanners: (payload) => ({ type: actionTypes.setBanners, payload }),
  setIcons: (payload) => ({ type: actionTypes.setIcons, payload }),
  setBlogs: (payload) => ({ type: actionTypes.setBlogs, payload }),
  setMobileDialog: (payload) => ({
    type: actionTypes.setMobileDialog,
    payload,
  }),
};

export function* saga() {
  // yield takeLatest(actionTypes.UserRequested, function* userRequested() {
  //     const {data: user} = yield getUserByToken();
  //
  //     yield put(actions.fulfillUser(user));
  // });
}
